var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate_num"},[_vm._v(" "+_vm._s(_vm.candidateData.length)+"표 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }